module.exports = __webpack_public_path__ + "static/media/google.7c8bc883.png";